module.exports = __webpack_public_path__ + "img/Gallery_2_17.7eb02643.jpeg";